import { isRouteErrorResponse, useRouteError } from "react-router";

export function RootErrorBoundary() {
  const error = useRouteError();
  const title = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : "Nie udało się otworzyć tej części aplikacji";
  const detail = isRouteErrorResponse(error)
    ? String(error.data?.detail || error.data || "Spróbuj ponownie.")
    : error instanceof Error
      ? error.message
      : "Nieznany błąd.";

  return (
    <main className="route-error" role="alert">
      <span className="eyebrow">BŁĄD MODUŁU</span>
      <h1>{title}</h1>
      <p>{detail}</p>
      <button className="primary-button" type="button" onClick={() => window.location.reload()}>
        Spróbuj ponownie
      </button>
    </main>
  );
}
